/*global jQuery:false */
/*jshint plusplus: false */

jQuery(function ($) {

    "use strict";

    function setup_main_menu() {

        var state = false,
            $window = $(window),
            $document = $(document),
            $html = $('html'),
            $body = $('body'),
            initial = true,
            $mainMenu = $('#menu-main-navigation'),
            $locationsTrigger = $('.locations-sub-menu'),
            $locationsMenu = $locationsTrigger.find('>ul'),
            $servicesTrigger = $('.services-sub-menu'),
            $servicesMenu = $servicesTrigger.find('>ul'),
            $servicesMenuWrap,
            $locationsMenuWrap,
            servicesMenuCount = $servicesMenu.children('li').length,
            servicesMenuHeight,
            timeout,
            close_locations_menu,
            close_services_menu,
            $menuIcon,
            init_menu_desktop = function () {

                $servicesMenu.find('>li >a').on('click.menu-desktop', function (event) {
                    var $target = $(event.target).parents('li');
                    
                    if ($target.find('>ul').length || $target.hasClass('break-line')) {
                        event.preventDefault();
                    }
                });

                function open_locations_menu() {
                    $locationsTrigger.addClass('menu-open');
                    $locationsMenu.show();
                    $body.addClass('menu-active');
                }

                close_locations_menu = function() {
                    $locationsTrigger.removeClass('menu-open');
                    $locationsMenu.hide();
                };

                function open_services_menu() {
                    $servicesTrigger.addClass('menu-open');
                    $servicesMenu.css({
                        display: 'block'
                    });
                    $servicesMenu.parent().css({
                        display: 'block'
                    });
                    servicesMenuHeight = $servicesMenu.outerHeight();

                    $body.addClass('menu-active');
                }

                close_services_menu = function() {
                    $servicesTrigger.removeClass('menu-open');
                    $servicesMenu.hide();
                    $servicesMenu.children('li').removeClass('menu-open');
                    $servicesMenu.find('.sub-menu').css({
                        display: 'none',
                        height: 'inherit'
                    });
                    $servicesMenu.parent().css({
                        display: 'none',
                        height: 'inherit'
                    });
                    $servicesMenu.parent().removeClass('sub-menu-active single double');
                    $servicesMenu.menuAim('reset');
                    $servicesMenu.find('a.hover').removeClass('hover');
                };

                function activateSubmenu(row) {
                    var $row = $(row),
                        $submenu = $row.children('ul'),
                        $submenu_li_parent = $row.children('a').parent(),
                        submenu_count = $submenu.children('li').length;

                    if ($submenu.length) {
                        $servicesMenuWrap.addClass('sub-menu-active');
                        if (submenu_count > servicesMenuCount) {
                            $servicesMenuWrap.addClass('double').removeClass('single');
                            var submenu_height = $submenu.outerHeight();

                            $servicesMenuWrap.css({
                                height: submenu_height
                            });
                            $submenu.css({
                                height: submenu_height,
                                display: 'block'
                            });
                        } else {
                            $servicesMenuWrap.addClass('single').removeClass('double');
                            $servicesMenuWrap.css({
                                height: servicesMenuHeight
                            });
                            $submenu.css({
                                height: servicesMenuHeight,
                                display: 'block'
                            });
                        }

                        clearTimeout(timeout);
                        timeout = false;
                    }

                    $row.children('a').addClass('hover');

                    $servicesMenu.parent().css({
                        display: 'block',
                        minHeight: servicesMenuHeight
                    });
                    $servicesMenu.css({
                        display: 'block',
                        minHeight: servicesMenuHeight
                    });

                }

                function deactivateSubmenu(row) {
                    var $row = $(row),
                        $submenu = $row.children('ul');

                    if (!timeout) {
                        timeout = setTimeout(function () {
                            $servicesMenu.parent().removeClass('sub-menu-active single double');
                        }, 50);
                    }

                    $row.find('a').removeClass('hover');
                    $submenu.css('display', 'none');
                }

                // Show / hide locations menu:
                $locationsTrigger.on('click.menu-desktop', '>a', function (event) {
                    event.preventDefault();
                    if ($locationsTrigger.hasClass('menu-open')) {
                        close_locations_menu();
                        if (!$servicesTrigger.hasClass('menu-open')) {
                            $body.removeClass('menu-active');
                        }
                    } else {
                        open_locations_menu();
                    }
                });

                // Hide locations or services menu on click outside of menu:
                $document.on('click.menu-desktop', function (event) {
                    var $target = $(event.target);
                    if ($locationsTrigger.hasClass('menu-open') && !$target.parents('.locations-sub-menu').length) {
                        close_locations_menu();
                        if (!$target.parents('.services-sub-menu').length) {
                            $body.removeClass('menu-active');
                        }
                    }

                    if ($servicesTrigger.hasClass('menu-open') && !$target.parents('.services-sub-menu').length) {
                        close_services_menu();
                        if (!$target.parents('.locations-sub-menu').length) {
                            $body.removeClass('menu-active');
                        }
                    }
                });

                // Show / hide services menu:
                $servicesTrigger.on('click.menu-desktop', '>a', function (event) {
                    event.preventDefault();
                    if ($servicesTrigger.hasClass('menu-open')) {
                        close_services_menu();
                        if (!$locationsTrigger.hasClass('menu-open')) {
                            $body.removeClass('menu-active');
                        }
                    } else {
                        open_services_menu();
                    }
                });

                $servicesMenu.menuAim({
                    triggerEvent: 'click',
                    activate: activateSubmenu,
                    deactivate: deactivateSubmenu
                });
            },
            exit_menu_desktop = function () {
                close_services_menu();
                close_locations_menu();
                $body.removeClass('menu-active');
                $locationsTrigger.off();
                $servicesTrigger.off();
                $document.off('.menu-desktop');
                $servicesMenu.find('>li >a').off();
                $servicesMenu.menuAim('destroy');
            },
            init_menu_mobile = function () {

                $servicesMenuWrap.css({
                    display: 'block',
                    height: 'inherit'
                });

                $locationsMenuWrap.css({
                    display: 'block',
                    height: 'inherit'
                });
                
                // Responsive icon and animating repsonsive menu
                $menuIcon.on('click.mobile-menu', function(event) {
                    $menuIcon.toggleClass('active');
                    if ($menuIcon.hasClass('active')) {
                        $body.addClass('no-scroll');
                        $menuIcon.text('CLOSE');
                    } else {
                        $body.removeClass('no-scroll');
                        $menuIcon.text('MENU');
                        $mainMenu.find('ul').hide();
                        $mainMenu.find('.menu-open').removeClass('menu-open');
                    }
                });
                        
                $mainMenu.find('ul').hide();
                $mainMenu.find('li:has(ul)').on('click.mobile-menu', function (event) {
                    event.stopPropagation();
                    var $target = $(event.target).parents('li').first(),
                        $sub = $target.find('ul:first');

                    if ($sub.length) {
                        event.preventDefault();
                        if ($target.hasClass('menu-open')) {
                            // $sub.hide();
                            $sub.slideUp(200);
                            $sub.find('ul').hide();
                            $sub.find('.menu-open').removeClass('menu-open');
                            $target.removeClass('menu-open');
                        } else {
                            // $sub.show();
                            $sub.slideDown(200);
                            $target.addClass('menu-open');
                        }
                    }
                    
                    if ($target.hasClass('break-line')) {
                        event.preventDefault();
                    }

                });                

                // Hide locations or services menu on click outside of menu:
                $document.on('click.mobile-menu', function (event) {
                    var $target = $(event.target);
                    if (!$target.hasClass('responsive-menu-icon') && !$target.parents('.responsive-menu-icon').length && !$target.parents('.menu-main-navigation').length) {
                        $menuIcon.removeClass('active');
                        $body.removeClass('no-scroll');
                        $menuIcon.text('MENU');
                        $mainMenu.find('ul').hide();
                        $mainMenu.find('.menu-open').removeClass('menu-open');
                    }
                });

            },
            exit_menu_mobile = function () {
                $body.removeClass('no-scroll');
                $body.removeClass('menu-active');
                $menuIcon.text('MENU');
                $menuIcon.removeClass('active');
                $mainMenu.find('li:has(ul)').off('.mobile-menu');
                $document.off('.mobile-menu');
                $menuIcon.off('.mobile-menu');
                $('li.menu-open').removeClass('menu-open');
                $mainMenu.find('ul').hide();
                $servicesMenuWrap.hide();
                $servicesMenu.show();
            },
            handle_resize = function () {
                var width = $window.width();

                if (width > 960 && state !== 'desktop') {
                    $html.addClass('menu-desktop').removeClass('menu-mobile');

                    if (!initial) {
                        exit_menu_mobile();
                    }
                    init_menu_desktop();

                    state = 'desktop';
                } else if (width <= 960 && state !== 'mobile') {
                    $html.addClass('menu-mobile').removeClass('menu-desktop');

                    if (!initial) {
                        exit_menu_desktop();
                    }
                    init_menu_mobile();

                    state = 'mobile';
                }

                initial = false;
            };

        // Add mobile dropdown icon
        $mainMenu.parent().before('<div class="responsive-menu-icon">MENU</div>');
        $menuIcon = $('.responsive-menu-icon');

        // Wrap menus:
        $locationsMenu.wrap('<div class="sub-menu-wrap"></div>');
        $servicesMenu.wrap('<div class="sub-menu-wrap"></div>');
        $servicesMenuWrap = $servicesMenu.parent();
        $locationsMenuWrap = $locationsMenu.parent();


        // Change width value on page load
        $(document).ready(function () {
            handle_resize();
        });

        // Change width value on user resize, after DOM
        $(window).resize(function () {
            handle_resize();
        });

    }
    setup_main_menu();

});